document.addEventListener('DOMContentLoaded', () => {
    let active_admin_main_content_tag = document.querySelector('body.active_admin #main_content')

    document.querySelectorAll('.modal-container').forEach(function (e) {
        if (e.parentElement !== active_admin_main_content_tag) {
            active_admin_main_content_tag.appendChild(e);
        }
    });
});
